<template>
  <div class="advancedSearch">
    <v-card>
      <v-card-title>
        <span>Advanced Search</span>
      </v-card-title>
      <v-card-text>
        <div v-for="(row, index) in searchRows" :key="index">
          <v-row>
            <v-col>
              <v-select
                label="Search Field"
                :items="fieldList"
                item-text="Description"
                item-value="ShortName"
                v-model="row.fieldName"
              ></v-select>
            </v-col>
            <v-col>
              <v-select label="Operator" :items="operators" v-model="row.condition"></v-select>
            </v-col>
            <v-col>
              <v-text-field label="Search Value" v-model="row.fieldValue"></v-text-field>
            </v-col>
            <v-col class="d-flex align-center justify-center" cols="1">
              <v-icon small color="primary" @click="addRow">mdi-plus</v-icon>
              <v-icon
                small
                color="primary"
                class="ml-2"
                @click="removeRow(index)"
                v-if="searchRows.length > 1"
              >
                mdi-delete
              </v-icon>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-checkbox label="Include all plans" v-model="includeAllPlans" reverse></v-checkbox>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="onCancelSearch"> Cancel </v-btn>
        <v-btn color="primary" outlined @click="SetAdvancedSearch"> Search </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AdvancedSearch',
  props: {
    advancedSearch: Boolean,
  },
  data() {
    return {
      fieldList: [],
      operators: ['=', '<', '>', '<=', '>=', 'Like'],
      searchRows: [{ fieldName: '', condition: null, fieldValue: '' }],
      includeAllPlans: false,
    };
  },
  mounted() {
    this.getFieldList();
  },
  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
  },
  methods: {
    async getFieldList() {
      try {
        let response = await this.$api.get(
          `/datadictionary/GetFieldList?formName=BasicData&planId=${this.currentPlanId}`
        );
        this.fieldList = response.data;
      } catch (err) {
        //
      } finally {
        //
      }
    },

    addRow() {
      this.searchRows.push({ field: null, operator: null, value: '' });
    },
    removeRow(index) {
      this.searchRows.splice(index, 1);
    },

    async SetAdvancedSearch() {
      //await this.$api.post("/member/getadvancedsearchresults", this.searchRows)
      const validRows = this.searchRows.filter((r) => r.fieldName && r.condition);
      this.$store.commit('setSearchMemberFields', validRows);
      this.$store.commit('setAdvancedSearch', {advancedSearch: true, includeAllPlans: this.includeAllPlans});
      this.$emit('closeDialog');
    },

    onCancelSearch(){
      this.searchRows = [{ fieldName: '', condition: null, fieldValue: '' }];
      this.$emit('closeDialog');
    },

    onFieldChange(index) {
      if (index === this.searchRows.length - 1) {
        this.searchRows.push({ fieldName: null, operator: null, value: '' });
      }
    },
  },
};
</script>
